// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PauseCircleOutlinedSvg from "@fishx/icons-svg/es/asn/PauseCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var PauseCircleOutlined = function PauseCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PauseCircleOutlinedSvg
  }));
};

PauseCircleOutlined.displayName = 'PauseCircleOutlined';
export default React.forwardRef(PauseCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PauseCircleOutlined.js
// module id = 3753
// module chunks = 0